import PlatformLink from "../../../components/ui/specialty/PlatformLink";
import CenterDiv from "../../../style/styled-components/components/CenterDiv";
import CompareTable from "../../../components/ui/specialty/CompareTable";
import ContactPoints from "../../../components/ui/members/ContactPoints";
import DiamondScope from "../../../components/ui/specialty/DiamondScope";
import DrawbackImage from "../../../../src/resources/images/drawback.png";
import PageTemplate from "../../../components/ui/common/template/PageTemplate";
import TitleTemplate from "../../../components/ui/common/template/TitleTemplate";
import UseBreakpoints from "../../../components/hooks/ui/UseBreakpoints";
import WorkScopes from "../../../components/ui/specialty/WorkScopes";
import img1 from "../../../resources/images/icon/3. 환급/1. 관세환급 진단 컨설팅, 소요량 사전심사 컨설팅.png";
import img3 from "../../../resources/images/icon/3. 환급/3. 개별환급 신청.png";
import img4 from "../../../resources/images/icon/3. 환급/4. 간이정액환급 신청.png";
import img5 from "../../../resources/images/icon/3. 환급/5. 기초원재료납세증명서 신청, 분할증명서 신청.png";
import img6 from "../../../resources/images/icon/3. 환급/6. 소요량 사전심사 대리.png";
import img7 from "../../../resources/images/icon/3. 환급/7. 품목별 소요량 관리 및 검토.png";
import img8 from "../../../resources/images/icon/3. 환급/8. 환급심사 대응.png";
import styled from "styled-components";
import { card } from "../../../style/styled-components/mixins";

const DrawbackPage = () => {
  const breakpoints = UseBreakpoints();
  return (
    <PageTemplate
      large
      image={DrawbackImage}
      title="환급"
      phrase="수출입통관부터 관세환급까지 One-Stop 서비스를 제공합니다."
      description="다년간 쌓은 수출입 통관 지식과 경력을 바탕으로 관세환급에 접근하여
      업무효율성을 증대시키고 차별화된 서비스를 제공합니다. 환급대상 원재료와
      수출을 파악하여 개별환급과 간이환급 중 최적화된 환급을 진단하여 RISK를
      최소화하고 잠재된 환급액을 찾아 기업 이윤을 극대화합니다."
    >
      <TitleTemplate
        title="관세환급"
        subHeader="요건에 맞는 정확한 환급 방법을 통하여 기업의 이윤을 극대화합니다."
        noImage
      />
      <CenterDiv>
        <CompareTable
          contents={[
            { div: "구분", content1: "개별환급", content2: "간이정액환급" },
            {
              div: "대상자",
              content1: "모든 수출입 기업",
              content2: "직전 2년간 매년 환급실적이 8억원 이하인 중소기업",
            },
            {
              div: "대상품목",
              content1: "모든 수출품목",
              content2: "간이정액환급률표에 기재된 수출품목",
            },
            {
              div: "제출서류",
              content1: "수출사실 확인서류, 납부세액 증명서류, 소요량 계산서",
              content2: "수출사실 확인서류",
            },
            {
              div: "환급금액",
              content1: "원재료 수입 시 납부세액 산출하여 환급금 지급",
              content2: "수출금액 1만원당 품목별 일정금액을 환급금으로 지급",
            },
          ]}
        />
      </CenterDiv>
      <TitleTemplate
        title="환급 관리"
        subHeader="환급전문가가 함께하는 AONE만의 특별한 관리시스템을 운영하고 있습니다."
        noImage
      />
      <CenterDiv>
        <DrawbackManageDiv breakpoints={breakpoints}>
          <div>
            <b>환급 data 관리</b>
            <ul>
              <li>환급 신청 및 기납증 발행 data 관리</li>
              <li>수출물품 1단위 환급액 변동성 점검</li>
              <li>
                기존 환급 이력 DB를 바탕으로 수출물품별 원재료로 구성된
                Master File 작성을 통한 DB 기반 검증
              </li>
            </ul>
          </div>
          <div>
            <b>Self-Audit</b>
            <ul>
              <li>제품별 원재료 소요량 일관성 점검</li>
              <li>조정고시대상 원재료에 대한 환급 이력 관리</li>
              <li>부산물 공제비율 변동성 점검</li>
            </ul>
          </div>
          <div>
            <b>컨설팅 연계</b>
            <ul>
              <li>향후 심사 수검대비 리스크 관리</li>
              <li>AM정보제공 분야 중 "환급" 관련 대응</li>
              <li>필요 시 소요량 사전심사 신청 등 유권해석</li>
            </ul>
          </div>
        </DrawbackManageDiv>
      </CenterDiv>

      <TitleTemplate
        title="업무 범위"
        subHeader="환급 신청부터 컨설팅 및 관리까지 환급 전문가가 고객사의 환급업무를 책임집니다."
        noImage
      />
      <WorkScopes
        contents={[
          { title: "관세환급 진단 컨설팅", icon: img1 },
          { title: "개별환급 신청", icon: img3 },
          { title: "간이정액환급 신청", icon: img4 },
          { title: "기초원재료 납세증명서 신청", icon: img5 },
          { title: "수입세액분할증명서 신청", icon: img5 },
          { title: "소요량 사전심사 컨설팅", icon: img1 },
          { title: "소요량 사전심사 대리", icon: img6 },
          { title: "품목별 소요량 관리 및 검토", icon: img7 },
          { title: "환급심사 대응", icon: img8 },
        ]}
      />
      <TitleTemplate title="ASCP 연계" noImage subHeader="에이원 자체 플랫폼 ASCP가 이 업무를 지원합니다." />
      <PlatformLink system="ACRIS" module="지능형 컴플라이언스" to="/scm/compliance"
        text="수출입 신고 데이터를 점검해 미신청 환급 기회를 자동으로 찾아내고, 신고 정합성을 상시 모니터링합니다." />
      <TitleTemplate
        title="Strength"
        subHeader="A-One만의 장점으로 고객을 힘껏 서포트해 나가겠습니다."
        noImage
      />
      <DiamondScope
        contents={[
          {
            title: "환급 전담조직",
            text: "환급 전문관세사 및 전문 컨설턴트로 구성된 환급 전담조직 보유",
          },
          {
            title: "풍부한 업무 경험",
            text: "다양한 산업 기업의 환급 컨설팅 및 환급대행업무 실적보유",
          },
          {
            title: "환급관련 법률 자문 제공",
            text: "환급관련 법률 자문 및 개정사항 상시 제공",
          },
          {
            title: "Consulting",
            text: "고객사 특성별 환급방법 컨설팅 및 세관 이슈 발생 시 적극 대응",
          },
        ]}
      />
      <TitleTemplate
        title="Contact Point"
        noImage
        subHeader="언제나 믿고 맡길 수 있는 최고의 멤버와 함께합니다."
      />
      {/* <ContactPoints members={["yeonghwan", "meenss"]} /> */}
      <ContactPoints members={["meenss"]} />
    </PageTemplate>
  );
};
export default DrawbackPage;
const DrawbackManageDiv = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ breakpoints }) => (breakpoints.md ? "repeat(3, minmax(0, 1fr))" : "minmax(0, 1fr)")};
  gap: 1rem;
  & > div {
    ${card}
    position: relative;
    overflow: hidden;
    padding: 1.5rem 1.4rem 1.4rem;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: linear-gradient(90deg, ${({ theme }) => theme.colors.accent}, ${({ theme }) => theme.colors.dark});
    }
    & > b {
      font-size: 1.1rem;
      font-weight: 800;
      letter-spacing: -0.01em;
      color: ${({ theme }) => theme.colors.dark};
    }
    & > ul {
      list-style: none;
      margin: 0.9rem 0 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      font-size: 0.9rem;
      line-height: 1.6;
      color: ${({ theme }) => theme.colors.foreground.dimmed};
      & > li {
        position: relative;
        padding-left: 0.8em;
        &::before {
          content: "•";
          position: absolute;
          left: 0;
          color: ${({ theme }) => theme.colors.accent};
        }
      }
    }
  }
`;
